import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { injectIntl } from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class CsatByDeviceBarChart extends Component {

  render() {

    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const csatByDevice = answersReport ? answersReport.csatByDevice : [];

    const categories = (csatByDevice || []).map(item => item.device);
    const data = (csatByDevice || []).map(item => (item.csat || 0) * 100);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height - (styles.wrapper.padding * 2),
        width: this.props.width - (styles.wrapper.padding * 2),
      },
      title: {
        text: intl.formatMessage({ id: 'csat' }),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          }, {
            count: !csatByDevice ? 0 : csatByDevice[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}%',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(CsatByDeviceBarChart),
  graphql`
    fragment CsatByDeviceBarChart_answersReport on AnswersReport {
      csatByDevice {
        device
        csat
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/CsatByDeviceBarChart/CsatByDeviceBarChart.js